import { render, staticRenderFns } from "./Gallery20.vue?vue&type=template&id=2d5a5042&scoped=true&"
import script from "./Gallery20.vue?vue&type=script&lang=js&"
export * from "./Gallery20.vue?vue&type=script&lang=js&"
import style0 from "./Gallery20.vue?vue&type=style&index=0&id=2d5a5042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5a5042",
  null
  
)

export default component.exports